import React,{Component,} from 'react';
import Icons from '../Icons/Icons';
import Modal from "react-bootstrap/Modal";
import { isSet } from '../../Utils/CommonFunctions';
import $ from 'jquery';
// import Wrp from '../../hoc/Wrp/Wrp';
// import * as ShipConstants from '../../Global/Constants';
import {formInputFieldsKeyRef} from '../../Containers/ShippingContainer/ShippingFunction';
import FormInputFields from '../FormInputFields';
// import Icons from '../Icons/Icons';

class ArrayElement extends Component{

	state={
		violations:{}
	}

	componentDidMount = ()=>{
		$(function () {
			// Hide all lists except the outermost.
			$('ul.treeArraySkeleton .treeSkeletonList').hide();
		});
		this.jqueryScript();
	}
	jqueryScript = ()=>{
		$(function () {
			// Hide all lists except the outermost.
			$('.treeArraySkeleton li').each(function(){
				if($(this).find('.treeSkeletonList').length===0){
					$(this).removeClass('has-children');
					$(this).find('.treetoggleIcon').remove();
				}
			})
			$('.treeArraySkeleton li > .treeSkeletonList').each(function (span) {
				var $subUl = $(this);
				var $parentLi = $subUl.parent('li');
				$parentLi.addClass('has-children');
				var $toggleIcon = '';
				if($subUl.find('li').length>0){
					$toggleIcon = '<span class="treetoggleIcon">+</span>';
				}else{
					$subUl.parent('li').removeClass('has-children');
					// $subUl;//.parent('li').removeClass('has-children');
				}
				
				
				if($parentLi.closest('li').find('.treetoggleIcon').length>0){
					$parentLi.closest('li').find('.treetoggleIcon').remove();
				}
				$parentLi.prepend($toggleIcon).find('.treetoggleIcon').on('click', function () {
					if($subUl.css('display') === 'none')
						{
							$(this).text('-');
							$subUl.slideDown('fast');
						}else{
							$(this).text('+');
							$subUl.slideUp('fast');
						}
					// $(this).text($(this).text() == '+' ? '-' : '+');
					// $subUl.slideToggle('fast');
				});
			});
		  });
	}
	componentDidUpdate = (prevProps)=>{
		this.jqueryScript();
	}

	validateArrayFields = (e) => {
		const {arrayElement} = this.props;
		let violations = {};
		if(arrayElement && arrayElement.fields && arrayElement.fields.length>0){
			arrayElement.fields.forEach(field => {
				if(field.name === "" && field.field_type_id === "") {
					// violations[field.indexes] = "name is mandatory";
					// violations[field.indexes] = "Field type is mandatory";
					violations[field.indexes] = {
						name:"name is mandatory",
						field_type:"Field type is mandatory"
					}
				}else if(field.name === "") {
					violations[field.indexes] = {
						name:"name is mandatory"
					}
				}else if(field.field_type_id === "") {
					violations[field.indexes] = {
						field_type:"Field type is mandatory"
					}
				}

				if(field.fields && field.fields.length>0) {
					this.validateArrayInnerFields(field.fields,violations);
				}
			})
		}
		console.log(violations);
		if(Object.keys(violations).length > 0) {
			console.log("non empty");
			this.setState({violations:violations});
		}else {
			console.log("empty");
			this.props.toogleArrayElementModel('apply');
		}
		// this.props.toogleArrayElementModel();
	}

	validateArrayInnerFields = (innerFields,violations) => {
		if(innerFields.length>0){
			innerFields.forEach(field => {
				if(field.name === "" && field.field_type_id === "") {
					// violations[field.indexes] = "name is mandatory";
					// violations[field.indexes] = "Field type is mandatory";
					violations[field.indexes] = {
						name:"name is mandatory",
						field_type:"Field type is mandatory"
					}
				}else if(field.name === "") {
					violations[field.indexes] = {
						name:"name is mandatory"
					}
				}else if(field.field_type_id === "") {
					violations[field.indexes] = {
						field_type:"Field type is mandatory"
					}
				}

				if(field.fields && field.fields.length>0) {
					this.validateArrayInnerFields(field.fields,violations);
				}
			})
		}
	}
	cancelHandler=()=>{
		this.setState({violations:{}})
		this.props.toogleArrayElementModel('cancel')
	}

	checkViolation = (indexes,name) => {
		let returnVal = false;
		const {violations} = this.state;
		if(violations && violations[indexes] && violations[indexes][name]) {
			returnVal = true;
		}
		return returnVal;
	}

	getViolationMsg = (indexes,name) => {
		let returnVal = "";
		const {violations} = this.state;
		if(violations && violations[indexes] && violations[indexes][name]) {
			returnVal = violations[indexes][name];
		}
		return returnVal;
	}

	render(){
		const {isArrayElementModalOpen,addRow,arrayElement} = this.props;
			//const {validateArrayFields} = this;
			// const {violations} = this.state;
			const {validateArrayFields,cancelHandler} = this;
			let variables = this.props.variablesAndFields && this.props.variablesAndFields.field_type ? this.props.variablesAndFields.field_type : null;
			// console.log('variables on bedore ',variables  , this.props.variablesAndFields || ""  )
			if (this.props.screen && (this.props.screen === "Steps" || this.props.screen === "Pages")) {
				variables = this.props.variablesAndFields;
			}
			let fieldTypeIndexMain = -1;
			let parentFieldtypeMain = 'Array';
			// console.log('variables afeter ',variables)
			if(this.props.variablesAndFields){
				fieldTypeIndexMain = variables.findIndex(i=>i.id===this.props.arrayElement.fieldtype_id);		
				if(fieldTypeIndexMain!==-1){
				    parentFieldtypeMain = variables[fieldTypeIndexMain].type_name;
				}		
			}
			console.log('ssss');
		return(
			<Modal fullscreen={true} show={isArrayElementModalOpen}>
			<Modal.Header>
			{arrayElement.variable_name} Array/Object Element
	        </Modal.Header>
	        <Modal.Body>
				{this.props.children}
				<div className="card m-2">
					<div className="card-body p-2">
						{(isSet(arrayElement.fields,[]).length===0)?
							<div className='workFlow_rules'>
								<ol className="workFlow_Count mb-0">
									<li className="workFlow_conditions workFlow-row position-relative label-align-center">
										<a href="#!" className="cursor-pointer "  onClick={e=>addRow("")}>
											<Icons iconType="AddPlusTwo" />
											<span className="pl-1">Add New Element</span>
										</a>
									</li>
								</ol>
							</div>
						:
						parentFieldtypeMain!== 'Messages'?
						<div className='row mb-2'>
							<div className="col-12">
								<a href="#!" className="text-info textUnderline cursor-pointer pr-2" onClick={e=>addRow("")}>
									<Icons iconType="AddPlusTwo" />
									<span className="pl-1" title="Fill the below and Add">Add Element </span>
								</a>
							</div>
						</div>
						:
						null
					}
						
						
						<ul className="treeArraySkeleton workFlow_rules">
							{this.treeHtmlElement(arrayElement,'def',isSet(arrayElement.window_id,null),isSet(arrayElement.is_constant,false))}
						</ul>
					</div>
				</div>
			</Modal.Body>
			<Modal.Footer>
		       {/* <div className="ml-md-auto py-2 py-md-0"> */}
		       		{/*<a onClick={validateArrayFields} style={{"zIndex":"1"}} className="btn btn-border border-default mr-2">  Cancel </a> */}
					{
						(

							// ["STEPS", "API", "HYPERTHREAD"].includes(arrayElement?.function_type) ||
							["Pages"].includes(this.props.screen)
						) ?

							<a href="#!" onClick={cancelHandler} className="btn border-default btn-border mr-2 cursor-pointer"> Cancel</a>
							: null
					}

		            <a href="#!" onClick={validateArrayFields} className="btn primary_bg"> Apply</a> 
		        {/* </div> */}
		    </Modal.Footer>
	    </Modal>
		)

	}
	treeHtmlElement = (variablesList,fieldKey='default',winId,is_constant)=>{
		return(
			<>
			{isSet(variablesList.fields,[]).map((item,itemIndex)=>{
				return(
					<li className={""} key={'withOutChild_'+fieldKey+'_'+itemIndex} id={'withOutChild_'+fieldKey+'_'+itemIndex}>
						{this.innerContent(item,itemIndex,winId,is_constant)}
			
					</li>
				)
			})}
				
			</>
		)
	}
	 innerContent = (item,itemIndex,winId=null,is_constant)=>{
	 			// const {violations} = this.state;
	 			const {getViolationMsg} = this;
				const max_value_cnt = 16;
				let decimal_cnt = 0;
				if(parseInt(item.max_value) > 10) {
					decimal_cnt = 10
				}else {
					decimal_cnt = parseInt(item.max_value);
				}

				let fieldTypeName = "";
				if(item.fieldtype_name) {
					fieldTypeName = item.fieldtype_name;
				}else if(item.field_type_name) {
					fieldTypeName = item.field_type_name;
				}
				let variables = this.props.variablesAndFields && this.props.variablesAndFields.field_type ? this.props.variablesAndFields.field_type : null;
				if(this.props.screen && this.props.screen==="Steps" || this.props.screen==="Pages") {
					variables = this.props.variablesAndFields;
				}


				let fieldTypeIndex = -1;
				let parentFieldtype = 'Array';
				//console.log('variables',variables)
				if(this.props.variablesAndFields){
					fieldTypeIndex = variables.findIndex(i=>i.id===this.props.arrayElement.fieldtype_id);		
					if(fieldTypeIndex!==-1){
					    parentFieldtype = variables[fieldTypeIndex].type_name;
					}		
				}
				//console.log('parentFieldtype',parentFieldtype)
			
				// let arrayElements = this.props.arrayElement.fields;
				// if(arrayElement.fieldsErrorArr && arrayElement.fieldsErrorArr.length>0){
				// 	arrayElements = arrayElement.fieldsErrorArr;
				// }
												
				const constantValue = {
					type:formInputFieldsKeyRef(fieldTypeName),
					label:'',
					value:item.field_expression,
					isDefault:false,
					attributes:{
						id:'constant_'+itemIndex,
						// ...constantAttributes
					},
					changeHandler:(val)=>this.props.changeHandler({target:{value:val,name:'field_expression'}},''+isSet(item.indexes,'')),
				}
				// && isSet(item.field_expression,null)==null
				// console.log('item',winId,item,item.name);
				return(
					
					<>
					{/* {(isSet(item.fields,[]).length>0 && (fieldTypeName === 'Array' || fieldTypeName === 'Object')) ? 
						<span className="treetoggleIcon" length={isSet(item.fields,[]).length}>+</span>
					:<span></span>} */}
					<ol className="workFlow_Count">
											<li className="workFlow_conditions workFlow-row position-relative">
											
												<div className="clearfix">
												<div className={getViolationMsg(item.indexes,'name') !== "" && item.name=="" ? "col-3 has-error float-left" : "col-3 float-left"}>
													<input type="text" className="form-control mandatory" name="name" value={item.name} 
														onChange={e=>this.props.changeHandler(e,''+isSet(item.indexes,''))}/>
													{getViolationMsg(item.indexes,'name') !== "" && item.name=="" ?
													<label className="error m-0">{getViolationMsg(item.indexes,'name')}</label>
													: null}
												</div>

												<div className="col-3 float-left">
													 <div className={getViolationMsg(item.indexes,'field_type') !== "" && item.field_type_id == "" ?"input-group has-error border-0":"input-group border-0"}> 
														<>
														<select className="form-control custom-arrow mandatory" name="field_type_id" onChange={e=>this.props.changeHandler(e,''+isSet(item.indexes,''))} value={item.field_type_id}>
															<option value="">-None-</option>
														{ variables?
															variables.map((arr,i) => {
																return <option key={i} value={arr.id}>{arr.type_name}</option>
															})
														: null }
														</select>
														
														</>
													{
														fieldTypeName === 'Decimal' ? 
															<>
															<div className='input-group-append'>
																<select className="form-control custom-arrow" name="max_value" value={item.max_value} onChange={e=>this.props.changeHandler(e,''+isSet(item.indexes,''))}>
																	{ [...Array(max_value_cnt)].map((elementInArray, index) => ( 
																				<option key={index} value={index + 1}>{index + 1}</option>
																			) 
																	) }
																	</select>
															 
																<select className="form-control custom-arrow" name="decimal_places" value={item.decimal_places} onChange={e=>this.props.changeHandler(e,''+isSet(item.indexes,''))}>
																		{decimal_cnt && [...Array(decimal_cnt)].map((elementInArray, index) => ( 
																					<option key={index} value={index}>{index}</option>
																				) 
																		)}
																</select>
															</div>
															
															</>
														:
														<></>
													}
													{ ((fieldTypeName === 'Array' || fieldTypeName === 'Object')) ? 
														<div className='input-group-append cursor-pointer' onClick={e=>this.props.addRow(item.indexes)} title={"Add "+fieldTypeName+' Element'}>
															<span className='input-group-text'>
																<a href="#!" className=" arrPlusIcon" >
																	<Icons iconType='AddPlusTwo'/>
																</a>
															</span>
														</div>
													:null }		
													
													 </div> 
													 {getViolationMsg(item.indexes,'field_type') !== "" && item.field_type_id =="" ?
													<label className="error m-0">{getViolationMsg(item.indexes,'field_type')}</label>
													: null}
												</div>												
												
												
												{ 
													(fieldTypeName !== 'Array' && fieldTypeName !== 'Object')? 
													parentFieldtype==='Messages'?
													<div className="col-3 float-left">
								            			{
								            			item.name && item.name ==='type'?
							            				<select className="form-control custom-arrow" value={item.field_expression} name="field_expression" onChange={e=>this.props.changeHandler(e,''+isSet(item.indexes,''))}>
								            				<option value="error">Error</option>
								            				<option value="info">Info</option>
								            				<option value="warning">Warning</option>
								            			</select>
								            			:
								            			null
								            			}

								            			{
							            				item.name && item.name ==='message'?
								            			<input type="text" className="form-control" name="field_expression" value={item.field_expression} onChange={e=>this.props.changeHandler(e,''+isSet(item.indexes,''))}/>
								            			:
								            			null
								            			}
					                                    	
						                        	</div>
												:(isSet(is_constant,false)===true)?
													<div className="col-3 float-left">
														<FormInputFields {...constantValue} />
													</div>
													:<></>
												: null }

												{
													parentFieldtype !== 'Messages'?
													<div className="float-right mr-2">
															<a href="#!" className="cursor-pointer" onClick={()=>this.props.deleteRow(isSet(item.indexes,''), item.id)}>
																<span className="svgIcon"> <Icons iconType="Delete" /> </span>
															</a>
													</div>
													:
													<></> 
												}												
												</div>
											</li>
										</ol>
										{(fieldTypeName === 'Array' || fieldTypeName === 'Object') ? 
												 
											<ul className='treeSkeletonList'>
												{this.treeHtmlElement(item,itemIndex,winId,is_constant)}
											</ul>
										:<></>
										 }
					</>
				)
	}
	
}

ArrayElement.defaultProps = {
	WindowListComp:null,
}
export default ArrayElement